import { BCMSRecord, Workflow, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import AddEmailContent from "components/pages/AdvancedAlertsPage/components/AddEmailContent";
import VerifyRecipientContent from "components/pages/AdvancedAlertsPage/components/VerifyRecipientContent";
import Classes from "model";

const steps = [ AddEmailContent, VerifyRecipientContent ];

export default function AdvancedAlertsAddEmailWorkflow(props) {
    const context = useBCMSContext();
    const { stepID } = useParams();

    BCMSRecord.globalControllerFor(Classes, context);

    return <Workflow steps={ steps } stepID={ stepID } value={ getDefault() } />
}

export const getWorkflowSteps = () => steps;

export const getDefault = () => {
    return {
        "email": ""
    };
}